const VueDatePicker = defineAsyncComponent(() =>
  import('@vuepic/vue-datepicker').then((m) => m.VueDatePicker)
)
// import '@vuepic/vue-datepicker/dist/main.css'
// import '~/../shared/assets/css/vue-datepicker-main.css'
// import '~/../shared/assets/css/datepicker.css'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('VueDatePicker', VueDatePicker)
})